var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-about-content-list-item-connector-line",class:("c-about-content-list-item-connector-line--" + _vm.current),style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }